/* eslint-disable react/prefer-stateless-function, quote-props, no-shadow, react/no-multi-comp, react/prop-types, react/jsx-no-bind */
import classNames from 'classnames';
import React from 'react';
import ProgressBar from 'es6/components/common/progress-bar';
import { t } from 'es6/services/localization';
import SoundManager from 'es6/services/sound-manager';

const ITEM_CLASSNAME = 'item';

const ITEMS_PER_ROW = 2;

/**
 * Plays the audio from an item package.
 *
 * @params {ItemPackage} itemPackage
 */
function playAudio(itemPackage) {
  if (itemPackage.sound) {
    SoundManager.play(itemPackage.sound);
  }
}

class ItemSummary extends React.Component {
  render() {
    const { disabled, itemPackages, onComplete } = this.props;

    // Only show item packages that have memories.
    const eligibleItemPackages = itemPackages.filter(itemPackage => !!itemPackage.memory);

    // Split rows into columns.
    const rows = _.chain(eligibleItemPackages)
      .groupBy((itemPackage, i) => Math.floor(i / ITEMS_PER_ROW))
      .toArray()
      .value();

    const className = classNames(
      'items-session-details items-session-details-item-summary',
      { 'disabled': this.props.disabled }
    );

    return (
      <section className={className}>
        <h4 className="action-message">{t('session-summary-header')}</h4>

        <section className="items-container">
          <section className="items">
            {rows.map((itemPackages, i) => {
              const props = {
                key: i,
                itemPackages,
                onComplete: !disabled ? onComplete : null,
              };

              return (<Row {...props} />);
            })}
          </section>
        </section>
      </section>
    );
  }
}

ItemSummary.propTypes = {
  disabled: React.PropTypes.bool,
  itemPackages: React.PropTypes.array,
  onComplete: React.PropTypes.func.isRequired,
};

ItemSummary.defaultProps = {
  disabled: false,
  itemPackages: [],
};

class Row extends React.Component {
  render() {
    const { itemPackages, onComplete } = this.props;
    const emptyCells = _.range(ITEMS_PER_ROW - itemPackages.length)
      .map(i => null);
    const cells = itemPackages.concat(emptyCells);

    return (
      <div className="item-row">
        {cells.map((itemPackage, i) => {
          if (itemPackage) {
            return (<Item key={i} onComplete={onComplete} itemPackage={itemPackage} />);
          } else {
            return (<div key={i} className={ITEM_CLASSNAME} />);
          }
        })}
      </div>
    );
  }
}

class Item extends React.Component {
  render() {
    const { itemPackage, onComplete } = this.props;
    const { memory } = itemPackage;
    const isComplete = memory.isComplete();

    // Set up variables to be used throughout the component.
    const className = classNames(ITEM_CLASSNAME, { 'mastered': isComplete });
    const prevProgress = memory.previous ? memory.previous.progress : 0;
    const masterTitle = memory.isComplete() ? t('item-mastered') : t('master-item');
    const onCueClick = playAudio.bind(null, itemPackage);
    const onMasterClick = isComplete ? null : onComplete.bind(null, itemPackage);

    return (
      <div className={className}>
        <div className="item-actions">
          <ProgressBar progress={memory.progress} prevProgress={prevProgress} showProgressTag showDifferenceTag className="progress-bar-item" />
          <span className="glyph glyph-master-check" title={masterTitle} onClick={onMasterClick}></span>
        </div>

        <div className="item-details">
          <div className="cue" onClick={onCueClick}>{itemPackage.getText()}</div>
          <div className="response">{itemPackage.getTranslation()}</div>
        </div>
      </div>
    );
  }
}

export default ItemSummary;
